import { Paginated, RequestedFeature } from "@vixi/types";
import { useMutation, useMutationState, useQueryClient } from "@tanstack/react-query";
import { optimisticDownvote, optimisticUpvote } from "./optimisticVote";
import { requestedFeaturesQueryOptions } from "@/queries/featureRequests/requestedFeaturesQuery";
import { debouncedVote } from "@/utils";

export const useDownvoteFeature = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationKey: ["downvote-feature"],
    mutationFn: async (featureId: RequestedFeature["id"]) => {
      // Optimistically update the cache
      queryClient.setQueryData<Paginated<RequestedFeature>>(
        requestedFeaturesQueryOptions().queryKey,
        optimisticDownvote(featureId),
      );

      try {
        const response = await debouncedVote(featureId, false);
        return response.data;
      } catch (error) {
        queryClient.setQueryData<Paginated<RequestedFeature>>(
          requestedFeaturesQueryOptions().queryKey,
          optimisticUpvote(featureId),
        );
      }
    },
  });

  return mutation;
};

export const useDownvoteFeatureState = () => {
  return useMutationState({
    filters: { mutationKey: ["downvote-feature"], status: "pending" },
  });
};
